import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);

  console.log('🔐 [AuthGuard] Checking auth:', { isAuthenticated, isInitialized, pathname });

  if (!isInitialized) {
    console.log('🔐 [AuthGuard] Not initialized, showing loading screen');
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    console.log('🔐 [AuthGuard] Not authenticated, redirecting to signin');
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to="/signin" state={{ from: pathname }} replace />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    console.log('🔐 [AuthGuard] Redirecting to requested location:', requestedLocation);
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  console.log('🔐 [AuthGuard] Authenticated, rendering children');
  return <>{children}</>;
}